export const chargerStatusService = {
  getBusyCharger: (data) => window.axios.post("get-busy-charger", data),
  getAvailableCharger: (data) =>
    window.axios.post("get-available-charger", data),
  getUnavailableCharger: (data) =>
    window.axios.post("get-unavailable-charger", data),
  getUnderMaintenanceCharger: (data) =>
    window.axios.post("get-under-maintence-charger", data),
};
